/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const get = (st: SpanTag): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/boral`;
  return fetchAPI(stleaf(st, 'gai1ye'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const findByName = (
  st: SpanTag,
  label: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/boral/${label}`;
  return fetchAPI(stleaf(st, 'thau2o'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getSiteLocation = (
  st: SpanTag,
  siteId: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/boral/location/${siteId}`;
  return fetchAPI(stleaf(st, 'ree3qu'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
